import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close_other",
  "use": "icon-close_other-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" aria-hidden=\"true\" viewBox=\"0 0 20 20\" id=\"icon-close_other\"><path d=\"M3 5h14V3H3v2zm12 8V7H5v6h10zM3 17h14v-2H3v2z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol